// export const API_ENDPOINT = "http://localhost:59356";

// export const API_ENDPOINT = "https://dnevne.at"

export const API_ENDPOINT = "https://infomilici.com";

// export const API_ENDPOINT = "http://localhost:58256";
